export var TriggerConditionOperator;
(function (TriggerConditionOperator) {
    TriggerConditionOperator["EQ"] = "equal";
    TriggerConditionOperator["NEQ"] = "not_equal";
    TriggerConditionOperator["GT"] = "greater_than";
    TriggerConditionOperator["GTE"] = "greater_than_or_equal";
    TriggerConditionOperator["LT"] = "less_than";
    TriggerConditionOperator["LTE"] = "less_than_or_equal";
    TriggerConditionOperator["AND"] = "and";
    TriggerConditionOperator["OR"] = "or";
    TriggerConditionOperator["XOR"] = "exclusive_or";
})(TriggerConditionOperator || (TriggerConditionOperator = {}));
export var TriggerTimeConditionType;
(function (TriggerTimeConditionType) {
    TriggerTimeConditionType["AT"] = "at";
    TriggerTimeConditionType["CRON"] = "cron";
})(TriggerTimeConditionType || (TriggerTimeConditionType = {}));
export var TriggerWebhookType;
(function (TriggerWebhookType) {
    TriggerWebhookType[TriggerWebhookType["ExecuteBefore"] = 0] = "ExecuteBefore";
    TriggerWebhookType[TriggerWebhookType["ExecuteAfter"] = 1] = "ExecuteAfter";
    TriggerWebhookType[TriggerWebhookType["PayloadOnly"] = 2] = "PayloadOnly";
    TriggerWebhookType[TriggerWebhookType["IgnorePayload"] = 3] = "IgnorePayload";
})(TriggerWebhookType || (TriggerWebhookType = {}));
